import { SVGProps } from 'react';

export interface BackIconProps extends SVGProps<SVGSVGElement> {
  /** Tailwind fill utility for the arrow. Defaults to the green used by TopPageNavigation. */
  pathClassName?: string;
}

export const BackIcon = ({ pathClassName = 'fill-fletchers-green-500', ...props }: BackIconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85355 5.14645C5.04882 5.34171 5.04882 5.65829 4.85355 5.85355L3.20711 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H3.20711L4.85355 10.1464C5.04882 10.3417 5.04882 10.6583 4.85355 10.8536C4.65829 11.0488 4.34171 11.0488 4.14645 10.8536L1.64645 8.35355C1.45118 8.15829 1.45118 7.84171 1.64645 7.64645L4.14645 5.14645C4.34171 4.95118 4.65829 4.95118 4.85355 5.14645Z"
        className={pathClassName || 'fill-fletchers-green-500'}
      />
    </svg>
  );
};
